export default __webpack_public_path__ + "static/RedHatDisplay-ExtraBold-161fa7e3fc5ece5990c8c73fecbfb031.ttf";